import React, { useEffect, useState } from "react";
import { Drawer, Spin, Tag, Timeline, Typography } from "antd";
import { get_agent_conversation_by_id } from "../../../../../api/endpoints/agents";
import { CONSTANTS } from "../../../../../utils/constants";
import moment from "moment";

const { Text, Paragraph } = Typography;

export default function ConversationDrawer({
	open,
	onClose,
	conversationId,
	orderNum,
}) {
	const [loading, setLoading] = useState(false);
	const [conversation, setConversation] = useState(null);

	useEffect(() => {
		const fetchConversation = async () => {
			if (!open || !conversationId) return;
			setLoading(true);
			try {
				const res = await get_agent_conversation_by_id(conversationId);
				setConversation(res);
			} catch (e) {
				console.error(e);
			} finally {
				setLoading(false);
			}
		};

		fetchConversation();
	}, [open, conversationId]);

	return (
		<Drawer
			title={`Conversación TRF #${orderNum ?? ""}`}
			width={480}
			onClose={onClose}
			open={open}
		>
			{loading ? (
				<Spin />
			) : !conversation ? (
				<Text type="secondary">No se encontró la conversación.</Text>
			) : (
				<Timeline>
					{conversation.messages?.map((m) => (
						<Timeline.Item
							key={m.id}
							color={CONSTANTS.AGENT_CONVERSATION[m.role]?.color}
						>
							<Tag
								color={CONSTANTS.AGENT_CONVERSATION[m.role]?.color || "blue"}
							>
								{CONSTANTS.AGENT_CONVERSATION[m.role]?.label || ""}
							</Tag>
							<Paragraph>{m.content}</Paragraph>
							<Text type="secondary" style={{ fontSize: 11 }}>
								{moment(m.created).format("DD-MM-YYYY hh:mm:ss")}
							</Text>
						</Timeline.Item>
					))}
				</Timeline>
			)}
		</Drawer>
	);
}
